if (!customElements.get('kiki-workshop-gallery')) {
  customElements.define('kiki-workshop-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.inView = false;
      this.toggle = this.querySelector('[data-gallery-toggle]');
      this.count = this.querySelector('[data-gallery-count]');
      this.status = this.querySelector('[data-gallery-status]');
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => { this.pause(); this.show(-1, true); }, options);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => { this.pause(); this.show(1, true); }, options);
      this.querySelector('.kiki-workshop-gallery__photos').addEventListener('pointerdown', () => this.pause(), options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => this.sync(), options);
      this.addEventListener('focusout', () => setTimeout(() => this.sync(), 0), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.sync();
    }
    pause() { this.paused = true; this.sync(); }
    show(direction, announce) {
      if (!this.slides.length) return;
      this.slides[this.index].hidden = true;
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = false;
      this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (announce) this.status.textContent = this.slides[this.index].querySelector('img').alt;
    }
    sync() {
      clearInterval(this.timer);
      this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      if (!this.paused && !this.hovered && this.inView && !document.hidden && !this.contains(document.activeElement) && this.slides.length > 1) {
        this.timer = setInterval(() => this.show(1, false), 6000);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}
